import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppOld from './AppOld';
import { Toaster } from "@/components/ui/sonner";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppOld />
    <Toaster position="top-right" richColors />
  </React.StrictMode>
);